import Button from '@carvana/ds-button';
import Spinner from '@carvana/ds-spinner';
import { useConfiguration } from '~/context/common/StaticContext';
import OopsErrorSection from './OopsErrorSection';
import {
  ButtonContainer,
  Description,
  Heading
} from './OopsErrorSection.styles';

type OwnProps = {
  isLoading: boolean;
  onGoHome: () => void;
  onTryAgain: () => void;
};

export default function PageError({
  isLoading,
  onGoHome,
  onTryAgain
}: OwnProps) {
  const { shouldUseTitleCasing } = useConfiguration();

  return (
    <OopsErrorSection>
      {isLoading ? (
        <Spinner size={57} />
      ) : (
        <>
          <Heading>Hmm... that’s not quite right!</Heading>
          <Description>
            Something went wrong when trying to load this section.
          </Description>
          <ButtonContainer>
            <Button
              data-analytics-id="Financing Prequalified Error Try Again Button"
              variant="secondary"
              onClick={onTryAgain}
              data-testid="try-again"
            >
              {shouldUseTitleCasing ? 'Try Again' : 'Try again'}
            </Button>
            <Button
              data-analytics-id="Financing Prequalified Error Go Home Button"
              onClick={onGoHome}
              data-testid="go-home"
            >
              Go Home
            </Button>
          </ButtonContainer>
        </>
      )}
    </OopsErrorSection>
  );
}
